import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import { ReactComponent as CoreSvg } from "../../assets/svg/SVG-TEST2.svg";
import CoreNetworkSVG from "./svg/CoreNetworkSVG";
import useIsIPhone from "../../hooks/useIsIphone";

// assets
import img1 from "../../assets/images/MACROCELLTOWERS.png";
import img2 from "../../assets/images/FIBERNETWORKS.png";
import img3 from "../../assets/images/DATACENTERS.png";
import img4 from "../../assets/images/ROOFTOPCELL.png";
import img5 from "../../assets/images/OUTDOORDAS.png";
import img6 from "../../assets/images/SMALLCELLS.png";
import img7 from "../../assets/images/INDOORDAS.png";
import prev from "../../assets/images/prev-blue.png";
import next from "../../assets/images/next-blue.png";

// css
import "./di-styles.css";

const CoreNetwork = () => {
  const isIPhone = useIsIPhone();
  const slider = useRef(null);

  // Slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  // Track screen size
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className="core-network-wrapper" id="core-network">
      {screenSize > 700 || isIPhone ? (
        <CoreNetworkSVG />
      ) : (
        <div style={{ padding: "50px" }} className="my-carousel-container">
          <h1 className="sub-header t-center">Core Network</h1>
          <Slider ref={slider} {...settings}>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Macro Cell Towers</h1>
              <img
                src={img1}
                alt="Macro Cell Towers"
                style={{ width: "100%" }}
              />
            </div>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Fiber Networks</h1>
              <img src={img2} alt="Fiber Networks" style={{ width: "100%" }} />
            </div>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Data Centers</h1>
              <img src={img3} alt="Data Centers" style={{ width: "100%" }} />
            </div>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Rooftop Cell Towers</h1>
              <img
                src={img4}
                alt="Rooftop Cell Towers"
                style={{ width: "100%" }}
              />
            </div>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Outdoor DAS</h1>
              <img src={img5} alt="Outdoor DAS" style={{ width: "100%" }} />
            </div>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Small Cells</h1>
              <img src={img6} alt="Small Cells" style={{ width: "100%" }} />
            </div>
            <div className="t-center">
              <h1 className="t-center t-swifblue fw-5">Indoor DAS</h1>
              <img src={img7} alt="Indoor DAS" style={{ width: "100%" }} />
            </div>
          </Slider>
          <div className="custom-arrows-core">
            <div onClick={() => slider?.current?.slickPrev()}>
              <img src={prev} alt="previous" />
            </div>
            <div onClick={() => slider?.current?.slickNext()}>
              <img src={next} alt="next" />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default CoreNetwork;
